// Strings that must stay English in every locale.
// Nested under the same namespaces as the rest of the lang files (e.g. landing.*).

export default {
    landing: {
        agencies_brand: "Northstar",
        agencies_brand_full: "Northstar Agency",
        agencies_client_harbor: "Harbor Dental",

        agencies_hero_chart_avg: "Avg Review",
        agencies_hero_chart_customers: "Clients",
        agencies_hero_chart_m1: "Jan",
        agencies_hero_chart_m2: "Feb",
        agencies_hero_chart_m3: "Mar",
        agencies_hero_chart_m4: "Apr",
        agencies_hero_chart_m5: "May",
        agencies_hero_chart_m6: "Jun",
        agencies_hero_chart_m7: "Jul",
        agencies_hero_chart_m8: "Aug",
        agencies_hero_chart_m9: "Sep",
        agencies_hero_chart_m10: "Oct",
        agencies_hero_chart_m11: "Nov",
        agencies_hero_chart_m12: "Dec",
        agencies_hero_chart_mrr: "MRR",
        agencies_hero_chart_pill: "+278% growth",
        agencies_hero_chart_reviews: "Total Reviews",
        agencies_hero_url: "portal.northstaragency.com",

        agencies_screen_1_list_range: "1–8 of 214",
        agencies_screen_1_rating: "4.82",
        agencies_screen_1_source_facebook: "Facebook",
        agencies_screen_1_source_google: "Google",
        agencies_screen_1_review_1_date: "2h ago",
        agencies_screen_1_review_1_name: "Casey M.",
        agencies_screen_1_review_1_text: "The team made our whole family feel at ease.",
        agencies_screen_1_review_2_date: "5h ago",
        agencies_screen_1_review_2_name: "Riley Q.",
        agencies_screen_1_review_2_text: "Dr. Patel explained everything clearly.",
        agencies_screen_1_review_3_date: "Yesterday",
        agencies_screen_1_review_3_name: "Jamie R.",
        agencies_screen_1_review_3_text: "Great cleaning, wait was a bit longer.",
        agencies_screen_1_review_4_date: "Yesterday",
        agencies_screen_1_review_4_name: "Avery B.",
        agencies_screen_1_review_4_text: "Friendly front desk and painless visit.",
        agencies_screen_1_review_5_date: "2d ago",
        agencies_screen_1_review_5_name: "Taylor H.",
        agencies_screen_1_review_5_text: "Insurance follow-up took too long.",
        agencies_screen_1_review_6_date: "3d ago",
        agencies_screen_1_review_6_name: "Jordan L.",
        agencies_screen_1_review_6_text: "Friendly, fair, and thorough. Booking again.",
        agencies_screen_1_review_7_date: "3d ago",
        agencies_screen_1_review_7_name: "Morgan S.",
        agencies_screen_1_review_7_text: "Solid experience overall, will recommend.",
        agencies_screen_1_review_8_date: "4d ago",
        agencies_screen_1_review_8_name: "Reese P.",
        agencies_screen_1_review_8_text: "Quick appointment and careful work.",
        agencies_screen_1_url: "portal.northstaragency.com/projects/1/reviews",

        agencies_screen_2_page_title: "Manage Overrides",
        agencies_screen_2_tile_advanced_pages: "Advanced Pages",
        agencies_screen_2_tile_api_mcp: "API / MCP",
        agencies_screen_2_tile_daily_emails: "Daily Emails",
        agencies_screen_2_tile_daily_sms: "Daily SMS",
        agencies_screen_2_tile_monthly_emails: "Monthly Emails",
        agencies_screen_2_tile_monthly_sms: "Monthly SMS",
        agencies_screen_2_tile_review_links: "Review Links",
        agencies_screen_2_url: "portal.northstaragency.com/agencies/1/projects/1",

        agencies_screen_3_app_name: "Claude",
        agencies_screen_3_badge: "MCP",
        agencies_screen_3_composer: "Ask anything…",
        agencies_screen_3_meta_period: "30 days",
        agencies_screen_3_meta_rating: "4.8★",
        agencies_screen_3_meta_reviews: "38 reviews",
        agencies_screen_3_next_steps: "Next steps",
        agencies_screen_3_step_1: "Seat patients within 10 minutes of check-in",
        agencies_screen_3_step_2: "Send insurance estimates same day by text",
        agencies_screen_3_step_3: "Return every phone inquiry within 2 hours",
        agencies_screen_3_summary: "3 low ratings cite long waits, slow insurance estimates, and missed callbacks.",
        agencies_screen_3_tool: "moregoodreviews.get_reviews",
        agencies_screen_3_user_message: "Give me a reputation report for Harbor Dental with next steps.",

        agencies_screen_4_locations_suffix: "locations",
        agencies_screen_4_page_title: "Projects",
        agencies_screen_4_project_1_name: "Brennan & Cole LLP",
        agencies_screen_4_project_1_website: "brennancole.com",
        agencies_screen_4_project_2_name: "Harbor Dental Group",
        agencies_screen_4_project_2_website: "harbordental.com",
        agencies_screen_4_project_3_name: "BrightPath Clinics",
        agencies_screen_4_project_3_website: "brightpath.com",
        agencies_screen_4_project_4_name: "Apex Legal Partners",
        agencies_screen_4_project_4_website: "apexlegal.com",
        agencies_screen_4_project_5_name: "Northwind Retail",
        agencies_screen_4_project_5_website: "northwindretail.com",
        agencies_screen_4_project_6_name: "Summit Physical Therapy",
        agencies_screen_4_project_6_website: "summitpt.com",
        agencies_screen_4_project_7_name: "Cedar Grove Dental",
        agencies_screen_4_project_7_website: "cedargrovedental.com",
        agencies_screen_4_reviews_suffix: "reviews",
        agencies_screen_4_url: "portal.northstaragency.com/agencies/1/projects",

        ai_mock_blank_url: "app.moregoodreviews.com",

        ai_mock_reply_badge: "AI Reply",
        ai_mock_reply_owner_label: "Response from the owner",
        ai_mock_reply_posted: "Posted {when}",
        ai_mock_reply_review_1_name: "Alex R.",
        ai_mock_reply_review_1_reply: "Thank you so much for your kind words! We’re glad the team could take care of you and hope to see you again soon.",
        ai_mock_reply_review_1_text: "Great experience from start to finish. The team was friendly, explained everything clearly, and made sure we were taken care of.",
        ai_mock_reply_review_1_when: "2 weeks ago",
        ai_mock_reply_review_2_name: "Riley P.",
        ai_mock_reply_review_2_reply: "We’re sorry this didn’t meet your expectations. Please email support@yourbusiness.com so we can make it right.",
        ai_mock_reply_review_2_text: "Sat in the waiting room for almost an hour and nobody told us why. Felt completely ignored the whole time and almost walked out.",
        ai_mock_reply_review_2_when: "1 week ago",

        ai_mock_suggestions_copied: "Copied",
        ai_mock_suggestions_copy: "Copy",
        ai_mock_suggestions_prompt: "Copy one to paste into Google",
        ai_mock_suggestions_text_1: "Friendly team, clear communication, and finished ahead of schedule. Easy from check-in all the way to the end. We highly recommend coming again!",
        ai_mock_suggestions_text_2: "Got us in the same day and walked us through every step. Super professional, kept us in the loop, and we will absolutely be coming back!",
        ai_mock_suggestions_text_3: "Great experience overall. They explained our options clearly, answered every question, and made sure we felt cared for throughout this visit!",

        ai_mock_tagging_review_1_name: "Sam K.",
        ai_mock_tagging_review_1_tag_1: "Parking Access",
        ai_mock_tagging_review_1_tag_2: "Transparent Pricing",
        ai_mock_tagging_review_1_text: "Easy parking right out front, and the final bill matched what they quoted.",
        ai_mock_tagging_review_2_name: "Riley P.",
        ai_mock_tagging_review_2_tag_1: "Wait Time",
        ai_mock_tagging_review_2_tag_2: "Front Desk",
        ai_mock_tagging_review_2_text: "Sat in the waiting room for almost an hour and nobody updated us.",
        ai_mock_tagging_review_3_name: "Morgan L.",
        ai_mock_tagging_review_3_tag_1: "Online Booking",
        ai_mock_tagging_review_3_tag_2: "Billing Accuracy",
        ai_mock_tagging_review_3_text: "Couldn’t get an appointment online, then got charged more than quoted.",
        ai_mock_tagging_review_4_name: "Alex R.",
        ai_mock_tagging_review_4_tag_1: "Staff Friendliness",
        ai_mock_tagging_review_4_tag_2: "On-Time Service",
        ai_mock_tagging_review_4_text: "The team was welcoming, and I was taken back right on time.",
        ai_mock_tagging_review_5_name: "Casey M.",
        ai_mock_tagging_review_5_tag_1: "Facility Cleanliness",
        ai_mock_tagging_review_5_tag_2: "Wait Time",
        ai_mock_tagging_review_5_text: "The lobby looked spotless, but I waited longer than expected.",
        ai_mock_tagging_review_6_name: "Jordan T.",
        ai_mock_tagging_review_6_tag_1: "Treatment Outcome",
        ai_mock_tagging_review_6_tag_2: "Quality of Care",
        ai_mock_tagging_review_6_text: "Treatment worked great. Already noticing the difference after one visit.",

        mcp_assistant_name: "AI Assistant",
        mcp_you: "You",

        review_flow_email_body: "Thanks again for choosing us. We’d love to hear how everything went — it only takes a minute and helps other customers find us.",
        review_flow_email_cta: "Leave a Review",
        review_flow_email_from: "From",
        review_flow_email_from_value: "Your Business",
        review_flow_email_subject: "How did everything go?",
        review_flow_email_subject_label: "Subject",
        review_flow_feedback: "Private Feedback",
        review_flow_form_name: "Karen L.",
        review_flow_form_submit: "Send Feedback",
        review_flow_form_submit_short: "Send",
        review_flow_preview_feedback_body: "Waited longer than expected and communication could have been better.",
        review_flow_preview_google_body: "Friendly, professional, and finished exactly as promised.",
        review_flow_preview_google_cancel: "Cancel",
        review_flow_preview_google_name: "Casey M.",
        review_flow_preview_google_post: "Post",
        review_flow_preview_google_posting: "Posting publicly across Google",
        review_flow_public_option: "Leave a public review",
        review_flow_rating_1: "Poor",
        review_flow_rating_2: "Fair",
        review_flow_rating_3: "Okay",
        review_flow_rating_4: "Good",
        review_flow_rating_5: "Great",
        review_flow_review_body: "Tap a rating below. It only takes a minute.",
        review_flow_review_prompt: "How was your experience?",
        review_flow_review_url: "review.yourbusiness.com",
    },
};
